export default __webpack_public_path__ + "static/media/hinted-subset-Roboto-Light.680fc6de.woff2";